import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Markets = Record<string, Market> | null;

export interface Market {
  midPrice: string;
  lastPrice?: string;
  markPrice: string;
  priceChangePct24h: string;
  turnover24h: string;
  fundingRate: string;
  fundingTime: string;
  fundingTimeBlocking?: FundingTimeBlocking;
  /**
   * 현재 활성 position bracket id (on-hours vs off-hours). off-hours 스위칭 시 서버가
   * market/pswaps 채널로 실시간 전달 (ERD-240 §6/§10). 없으면 specs instrument.positionBracket로 폴백.
   */
  positionBracket?: string;
}

export type FundingTimeBlockingNone = { None: { interval: number } };
export type FundingTimeBlockingLikely = { Likely: { interval: number } };
export type FundingTimeBlockingScheduled = { Scheduled: { from: string; until: string } };
export type FundingTimeBlocking = FundingTimeBlockingNone | FundingTimeBlockingLikely | FundingTimeBlockingScheduled;

export const marketsAtom = atom<Markets>(null);

export const subscribeMarketsBunja = createTableAccumulatorBunja(
  'market/pswaps',
  (store) => (wsData) => store.set(marketsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
subscribeMarketsBunja.debugLabel = 'subscribeMarketsBunja';
